/**
 * The tag slugs the file-based tag suggestions are keyed on
 * (tag-suggestions.ts, whose deliverable hints the type guess reads too). They
 * were the homepage carousel's tags, each with a leaderboard, and the
 * marketplace's "Explore by tag" rail's, until the owner removed both on
 * 2026-10-20.
 *
 * A hard-coded list on purpose, never read from the `tags` collection: that
 * collection only feeds the seller's tag picker, its counts drift, and on
 * 2026-09-30 its `music` document was named "sound-effects" while no
 * `sound-effects` document existed at all. Buyer-facing tag data comes from
 * live products (src/lib/catalog-tags.ts), and these slugs are matched against
 * that data exactly, so "template" (singular) on a product does not count
 * towards "templates".
 *
 * Labels are written by hand because tagLabel() title-cases each part, which
 * turns `ui-kits` into "Ui Kits" and `3d-models` into "3d Models".
 *
 * Most of these slugs name a catalogue type or purpose now
 * (catalog-taxonomy.ts), which no product keeps as a tag; suggestTagsForProduct
 * leaves those out and offers only the rest (tools such as notion and canva).
 */

export type HomeTag = {
  /** The normalized tag, exactly as it appears in a product's productTags. */
  slug: string;
  /** How the carousel names it. */
  label: string;
};

export const HOME_TAGS: readonly HomeTag[] = [
  { slug: 'templates', label: 'Templates' },
  { slug: 'notion', label: 'Notion' },
  { slug: 'canva', label: 'Canva' },
  { slug: 'planners', label: 'Planners' },
  { slug: 'printables', label: 'Printables' },
  { slug: 'ebooks', label: 'Ebooks' },
  { slug: 'courses', label: 'Courses' },
  { slug: 'fonts', label: 'Fonts' },
  { slug: 'icons', label: 'Icons' },
  { slug: 'graphics', label: 'Graphics' },
  { slug: 'mockups', label: 'Mockups' },
  { slug: 'brushes', label: 'Brushes' },
  { slug: 'presets', label: 'Presets' },
  { slug: 'ui-kits', label: 'UI kits' },
  { slug: '3d-models', label: '3D models' },
  { slug: 'code', label: 'Code' },
  { slug: 'plugins', label: 'Plugins' },
  { slug: 'music', label: 'Music' },
  { slug: 'sound-effects', label: 'Sound effects' },
  { slug: 'game-assets', label: 'Game assets' },
];

export const HOME_TAG_SLUGS: readonly string[] = HOME_TAGS.map((t) => t.slug);
